import { z } from 'zod';

// TODO: reduce integer and float to just number. It seems there is no need to distinguish between them
export const FilterType_S = z
    .literal('keyword')
    .or(z.literal('integer'))
    .or(z.literal('float'))
    .or(z.literal('number'))
    .or(z.literal('boolean'));
